import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Notiflix from "notiflix";

// ANT DESIGN IMPORTS
import {
  Spin,
  Typography,
  Collapse,
  Button,
  Input,
  Divider,
  Modal,
  Row,
  Col,
  Form,
  Select,
  Tooltip,
  DatePicker,
  InputNumber,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
import styles from "../../../../../../assets/styles/styles";
import { useNavigate } from "react-router-dom";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";

const { Text, Title } = Typography;
const { Panel } = Collapse;
const dateFormat = "YYYY-MM-DD";

const EditLimit = (props) => {
  const { currentCustomerObj, userData, limitObj, refreshList } = props;
  const { session } = userData;
  const [useForm] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [limitDetail, setLimitDetail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [inputField, setInputField] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [liabilityData, setLiabilityData] = useState([]);
  const liabilityCategory = Form.useWatch("liabilityCategoryId", useForm);
  const navigate = useNavigate();

  useEffect(() => {
    getTemplate();
  }, []);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${apiConfig.ClientLimit}/details`;

    const params = {
      limitLineNumber: limitObj?.limitLineNo,
    };

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setLimitDetail(objDetail);

        setInputField([
          {
            name: labelConfig.liabilityId,
            value: objDetail?.liabilityId,
            type: "general",
          },
          {
            name: labelConfig.limitLineNo,
            value: objDetail?.limitLineNumber,
            type: "general",
          },
          {
            name: labelConfig.currency,
            value: objDetail?.currency?.code,
            type: "general",
          },

          {
            name: labelConfig.liabilityCategory,
            value: objDetail?.liabilityCategory,
            type: "general",
          },
          {
            name: labelConfig.status,
            value: objDetail?.isActive ? "Active" : "Inactive",
            type: "general",
          },
          {
            name: labelConfig.revolvingLine,
            value: objDetail?.revolvingLine ? "Yes" : "No",
            type: "general",
          },
          {
            name: labelConfig.retrieveCollateral,
            value: objDetail?.retrieveCollaterals ? "Yes" : "No",
            type: "general",
          },
          {
            name: labelConfig.limitEndDate,
            value: objDetail?.limitEndDate,
            type: "general",
          },
          {
            name: labelConfig.globalLimit,
            value: objDetail.globalLimit,
            type: "amount",
          },
          {
            name: labelConfig.accountLimit,
            value: objDetail.accountLimit,
            type: "amount",
          },
          {
            name: labelConfig.cardLimit,
            value: objDetail.cardLimit,
            type: "amount",
          },
          {
            name: labelConfig.utilizedLimit,
            value: objDetail.utilizedLimit,
            type: "utilization",
          },
          {
            name: labelConfig.unUsedLimit,
            value: objDetail.unUsedLimit,
            type: "utilization",
          },
          {
            name: labelConfig.unAuthorisedLimit,
            value: objDetail.unAuthorisedLimit,
            type: "utilization",
          },
          {
            name: labelConfig.digitsAfterDecimal,
            value: objDetail.currency?.digitsAfterDecimal,
            type: "utilization",
          },
          {
            name: labelConfig.inMultiplesOf,
            value: objDetail.currency?.inMultiplesOf,
            type: "utilization",
          },
        ]);

        // SHOW THE SAVED DATA
        useForm.setFieldsValue({
          liabilityId: objDetail?.liabilityId,
          limitLineNumber: objDetail?.limitLineNumber,
          currencyCode: objDetail?.currency.code,
          liabilityCategoryId: objDetail?.liabilityCategory,
          isActive: objDetail?.isActive,
          revolvingLine: objDetail?.revolvingLine,
          retrieveCollaterals: objDetail?.retrieveCollaterals,
          limitEndDate: dayjs(
            BOM.FormatArrayDate(objDetail?.limitEndDate),
            dateFormat
          ),
          // globalLimit: objDetail?.globalLimit,
          accountLimit: objDetail?.accountLimit,
          cardLimit: objDetail?.cardLimit,
          utilizedLimit: objDetail?.utilizedLimit,
          unUsedLimit: objDetail?.unUsedLimit,
          unAuthorisedLimit: objDetail?.unAuthorisedLimit,
          digitsAfterDecimal: objDetail?.currency?.digitsAfterDecimal,
          inMultiplesOf: objDetail?.currency?.inMultiplesOf,
        });
        setIsLoading(false);
      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
    getDetailById();
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  function getTemplate() {
    const params = {};
    const url = `${apiConfig.ClientLimit}/template`;
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempLiability = [];
        let tempCurrency = [];

        objDetail?.liabilityCategories.forEach((element) => {
          tempLiability.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.currencyOptions?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        setCurrencyData(tempCurrency);
        setLiabilityData(tempLiability);
        setIsLoading(false);
      }
    });
  }

  const onSubmitLimit = (formValues) => {
    const url = `${apiConfig.ClientLimit}/${formValues.limitLineNumber}`;
    formValues.limitEndDate = BOM.DateTime(
      formValues.limitEndDate,
      "only-date"
    );
    // formValues.clientId = currentCustomerObj.id;
    // formValues.liabilityId = currentCustomerObj.id;
    formValues.dateFormat = "dd MMMM yyyy";

    const body = {
      ...formValues,
      locale: "en",
      method: "PUT",
      session,
    };

    // console.log(body); return
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.updateLimitMsg);

          // close modal
          setIsModalOpen(false);

          //refresh the list
          refreshList();

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <>
      <Tooltip title={`Edit`}>
        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Edit Limit"
        open={isModalOpen}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmitLimit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onSubmitLimit}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider orientation="left">{labelConfig.generalInfo}</Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.liabilityId}
                name="liabilityId"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.liabilityId),
                  },
                ]}
              >
                <Input
                  className="of-bold-disable-input"
                  disabled
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.liabilityId
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.limitLineNo}
                name="limitLineNumber"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.limitLineNo),
                  },
                ]}
              >
                <Input
                  className="of-bold-disable-input"
                  disabled
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.limitLineNo
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                disabled
                label={labelConfig.currency}
                name="currencyCode"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.currency),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.currency} *`,
                    "select"
                  )}
                  options={currencyData}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                disabled
                label={labelConfig.liabilityCategory}
                name="liabilityCategoryId"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.liabilityCategory),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.liabilityCategory} *`,
                    "select"
                  )}
                  options={liabilityData}
                  showSearch
                />
              </Form.Item>
            </Col>
            {liabilityCategory && (
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item name="accountLimit" label={labelConfig.limitAmount}>
                  <InputNumber
                    formatter={(value) =>
                      value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(value) =>
                      value ? value.replace(/(,*)/g, "") : ""
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.limitAmount
                    )}
                    style={styles.ofInputFieldNumber}
                  />
                </Form.Item>
              </Col>
            )}
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.status}
                name="isActive"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.status),
                  },
                ]}
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.status} *`,
                    "select"
                  )}
                  options={staticConfig.statusData}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                disabled
                label={labelConfig.revolvingLine}
                name="revolvingLine"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.revolvingLine),
                  },
                ]}
              >
                <Select
                  disabled
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.revolvingLine} *`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.retrieveCollateral}
                name="retrieveCollaterals"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.retrieveCollateral),
                  },
                ]}
              >
                <Select
                  disabled
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.retrieveCollateral} *`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.limitEndDate}
                name="limitEndDate"
                rules={[
                  () => ({
                    validator(_, value) {
                      const today = dayjs();
                      if (!value) {
                        return Promise.reject(
                          new Error(`Please select end date`)
                        );
                      }
                      if (value?.isBefore(today, "day")) {
                        return Promise.reject(
                          new Error(
                            `End date cannot be lesser than ${today.format(
                              "YYYY-MM-DD"
                            )} (Today)`
                          )
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <DatePicker style={{ width: "100%", height: 35 }} />
              </Form.Item>
            </Col>
          </Row>
          {/* <Row>
            <Divider orientation="left">{labelConfig.amountInformation}</Divider>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.globalLimit}
                name="globalLimit"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.globalLimit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.globalLimit)}
                  style={styles.ofInputFieldNumber}
                  disabled
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.accountLimit}
                name="accountLimit"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.accountLimit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.accountLimit)}
                  style={styles.ofInputFieldNumber}
                  disabled
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.cardLimit}
                name="cardLimit"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.cardLimit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.cardLimit)}
                  style={styles.ofInputFieldNumber}
                  disabled
                />
              </Form.Item>
            </Col>
          </Row> */}
          {/* <Row>
            <Divider orientation="left">{labelConfig.utilizationInformation}</Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.utilizedLimit}
                name="utilizedLimit"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.utilizedLimit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.utilizedLimit)}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.unUsedLimit}
                name="unUsedLimit"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.unUsedLimit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.unUsedLimit)}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.unAuthorisedLimit}
                name="unAuthorisedLimit"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.unAuthorisedLimit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.unAuthorisedLimit)}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.digitsAfterDecimal}
                name="digitsAfterDecimal"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.digitsAfterDecimal),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.digitsAfterDecimal)}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.inMultiplesOf}
                name="inMultiplesOf"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.inMultiplesOf),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.inMultiplesOf)}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
          </Row> */}
        </Spin>
      </Modal>
    </>
  );
};

export default EditLimit;
